import { LanguageActionTypes } from 'actions/language';
import createReducer from 'utils/create-reducer';
import type { Language } from 'app/types/graphql';
import { setStorage, getStorage, removeStorage } from 'utils/storage';

export type LanguageState = {
  preferredLanguage: Language | null;
};

const LANGUAGE_COOKIE_NAME = 'preferred_language_code';

const DEFAULT_LANGUAGE: Language = { code: 'en', name: 'English', translationAutomation: { resources: true } };

const getPersistedLanguage = (): string | null => getStorage(LANGUAGE_COOKIE_NAME) || null;

export const initialLanguageState: LanguageState = {
  preferredLanguage: getPersistedLanguage() ? ({ code: getPersistedLanguage() } as Language) : DEFAULT_LANGUAGE,
};

const setLanguageState = (language: string | null) => {
  if (language) {
    setStorage(LANGUAGE_COOKIE_NAME, language, { domain: window.location.hostname, sameSite: 'None', secure: true });
  } else {
    removeStorage(LANGUAGE_COOKIE_NAME, { domain: window.location.hostname, sameSite: 'None', secure: true });
  }
};

const handlers = {
  [LanguageActionTypes.SET_LANGUAGE]: (state: LanguageState, payload: Language): LanguageState => {
    const newState = {
      ...state,
      preferredLanguage: payload,
    };
    setLanguageState(newState.preferredLanguage?.code);
    return newState;
  },
  [LanguageActionTypes.RESET_LANGUAGE]: (): LanguageState => {
    setLanguageState(null);
    return initialLanguageState;
  },
};

export const languageReducer = createReducer<LanguageState>(handlers);
